<template>
  <div class="sort-by">
    <div class="flex flex-wrap w-full">
      <div class="spacer-x-1 sort-by__label">
        <p>Sort By:</p>
      </div>
      <div class="flex-shrink-0 sort-by__dropdown">
        <div class="dropdown" v-if="sortAndOrderBy">
          <button class="btn btn-block btn-default dropdown-toggle w-full" type="button" id="billboard-sort-by" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            {{ sortAndOrderBy.label }}
          </button>
          <ul class="dropdown-menu" aria-labelledby="billboard-sort-by">
            <li v-for="(option, index) in options" :key="index">
              <router-link
                :to="{ query: routerLinkQueryForOption(option) }"
                @click.native="sortAndOrderBy = option">
                {{ option.label }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { find, assign } from 'lodash'

export default {
  props: {
    value: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      sort: 'created_at',
      order: 'desc'
    }
  },

  computed: {
    sortAndOrderBy: {
      get () {
        return find(this.options, (option) => {
          return option.sort === this.value.sort &&
            option.order === this.value.order
        })
      },

      set ({ sort, order }) {
        this.$emit('input', { sort, order })
        this.sort = sort
        this.order = order
      }
    },

    options () {
      return [
        {
          label: 'Soonest start date',
          sort: 'start_date',
          order: 'asc'
        },
        {
          label: 'Most recent creation date',
          sort: 'created_at',
          order: 'desc'
        },
        {
          label: 'Most recently modified',
          sort: 'updated_at',
          order: 'desc'
        },
        {
          label: 'Least recently modified',
          sort: 'updated_at',
          order: 'asc'
        }
      ]
    }
  },

  methods: {
    routerLinkQueryForOption (option) {
      return assign({}, this.$route.query, {
        sort: option.sort,
        order: option.order
      })
    }
  }
}
</script>
